/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable comma-dangle */
/* eslint-disable arrow-parens */
/* eslint-disable camelcase */
/* eslint-disable space-before-function-paren */
/* eslint-disable react/prop-types */
/* eslint-disable object-curly-spacing */
/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lonely-if */
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {injectIntl} from 'react-intl';

import VM from 'openblock-vm';
import JSZip from 'jszip';

import {setStageSize} from '../reducers/stage-size';
import {STAGE_SIZE_MODES, STAGE_DISPLAY_SIZES} from '../lib/layout-constants';
import {openUploadProgress, closeUploadProgress} from '../reducers/modals';
import {updateFlashProgress, resetFlashProgress} from '../reducers/flash-progress';
import {updateInitProgress, resetInitProgress} from '../reducers/init-progress';
import {showAlertWithTimeout} from '../reducers/alerts';
import {
    setEsp32UploadPhase,
    setEsp32UploadText,
    appendEsp32UploadText,
    setEsp32AbortEnabled,
    resetEsp32Upload,
    ESP32_UPLOAD_PHASES
} from '../reducers/esp32-upload';

import HardwareHeaderComponent from '../components/hardware-header/hardware-header.jsx';

import { ESPLoader, Transport } from "../../lib";
import { serial } from "web-serial-polyfill";
import CryptoJS from 'crypto-js';

const serialLib = !navigator.serial && navigator.usb ? serial : navigator.serial;
let _sharedPort = null;
let _sharedPortBaudrate = null;

// Export getters
export const getSharedSerialPort = () => _sharedPort;
export const getSharedPortBaudrate = () => _sharedPortBaudrate;

// ✅ Export setter để Console có thể cập nhật shared port
export const setSharedSerialPort = (port, baudrate) => {
    _sharedPort = port;
    _sharedPortBaudrate = baudrate;
    console.log(`✓ Shared port set from external source (baudrate: ${baudrate})`);
};

class HardwareHeader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleUpload',
            'handleEsp32S3Upload'
        ]);
    }

    async handleEsp32S3Upload(code) {
        try {
            // Thông báo console để giải phóng port
            window.dispatchEvent(new CustomEvent('beforeUpload'));
            await new Promise(resolve => setTimeout(resolve, 500));

            this.props.onOpenUploadProgress?.();
            this.props.onResetFlashProgress?.();
            this.props.onResetInitProgress?.();
            this.props.onResetEsp32Upload?.();
            this.props.onSetEsp32UploadPhase?.(ESP32_UPLOAD_PHASES.uploading);
            this.props.onAppendEsp32UploadText?.('Starting upload...\r\n');

            // ✅ Kiểm tra shared port trước khi request mới
            let port = _sharedPort;

            if (!port) {
                console.log('⚠ No shared port found, requesting new port...');
                port = await serialLib.requestPort({});
                _sharedPort = port;
                _sharedPortBaudrate = parseInt(this.props.baudrate || '115200', 10);
            } else {
                // ✅ Kiểm tra port còn hợp lệ không
                if (!port.readable || !port.writable) {
                    console.warn('⚠ Shared port no longer valid, requesting new port...');
                    _sharedPort = null;
                    _sharedPortBaudrate = null;
                    port = await serialLib.requestPort({});
                    _sharedPort = port;
                    _sharedPortBaudrate = parseInt(this.props.baudrate || '115200', 10);
                } else {
                    console.log('✓ Using valid shared port from Scan/Play');
                }
            }

            this.props.onUpdateInitProgress?.(25);
            this.props.onAppendEsp32UploadText?.('Compiling code on server...\r\n');

            const response = await fetch(this.props.uploadUrl || 'https://robo-api.windify.edu.vn/api/esp32s3/compile', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    code: code
                })
            });

            if (!response.ok) {
                // Try to get error message from server response
                let errorMessage = `HTTP error! status: ${response.status}`;
                try {
                    const errorData = await response.json();
                    if (errorData && errorData.message) {
                        errorMessage = errorData.message;
                    } else if (errorData && errorData.error) {
                        errorMessage = errorData.error;
                    }
                } catch (e) {
                    // If can't parse JSON, try text
                    try {
                        const errorText = await response.text();
                        if (errorText) {
                            errorMessage = errorText;
                        }
                    } catch (e2) {
                        // Use default error message
                    }
                }
                this.props.onAppendEsp32UploadText?.(`\r\n❌ Compile error:\r\n${errorMessage}\r\n`);
                this.props.onSetEsp32UploadPhase?.(ESP32_UPLOAD_PHASES.error);
                this.props.onSetEsp32AbortEnabled?.(true);
                throw new Error(errorMessage);
            }
            this.props.onUpdateInitProgress?.(50);
            this.props.onAppendEsp32UploadText?.('✓ Compile success, downloading firmware...\r\n');
            const zipBlob = await response.blob();
            this.props.onUpdateInitProgress?.(75);
            this.props.onAppendEsp32UploadText?.('✓ Extracting firmware files...\r\n');
            const zip = new JSZip();
            const zipData = await zip.loadAsync(zipBlob);
            const flashMap = {
                'bootloader.bin': 0x0000,
                'partitions.bin': 0x8000,
                'firmware.bin': 0x10000
            };
            const fileArray = [];

            for (const [fileName, address] of Object.entries(flashMap)) {
                const file = zipData.files[fileName];

                if (!file || file.dir) {
                    console.warn(`Không tìm thấy ${fileName} trong zip`);
                    continue;
                }
                const binaryData = await file.async('binarystring');

                fileArray.push({
                    data: binaryData,
                    address: address
                });

                console.log(`✓ ${fileName}: ${(binaryData.length / 1024).toFixed(2)} KB -> 0x${address.toString(16)}`);
            }
            this.props.onUpdateInitProgress?.(100);
            this.props.onAppendEsp32UploadText?.('✓ Firmware ready, starting flash...\r\n');

            if (fileArray.length === 0) {
                const errMsg = 'Không tìm thấy file .bin nào trong build';
                this.props.onAppendEsp32UploadText?.(`\r\n❌ Error: ${errMsg}\r\n`);
                this.props.onSetEsp32UploadPhase?.(ESP32_UPLOAD_PHASES.error);
                this.props.onSetEsp32AbortEnabled?.(true);
                throw new Error(errMsg);
            }
            await this.flashToESP32(_sharedPort, fileArray);

            console.log('✓ Flash hoàn tất!');
            this.props.onAppendEsp32UploadText?.('\r\n✓ Flash completed successfully!\r\n');
            this.props.onSetEsp32UploadPhase?.(ESP32_UPLOAD_PHASES.success);
            this.props.onSetEsp32AbortEnabled?.(true);
            fileArray.length = 0;

            console.log('✓ Đã xóa tất cả file tạm khỏi memory');
            this.props.onShowUploadEsp32Success?.();

            // Thông báo console có thể tiếp tục
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('afterUpload'));
                this.props.onCloseUploadProgress?.();
            }, 2000);

        } catch (error) {
            console.error('Lỗi khi upload code cho ESP32-S3:', error);

            // ✅ Reset shared port nếu có lỗi liên quan đến kết nối
            if (error.message && (error.message.includes('disconnected') || error.message.includes('not found'))) {
                console.warn('⚠ Device disconnected during upload, resetting port');
                _sharedPort = null;
                _sharedPortBaudrate = null;
            }

            // Only append error if not already set (to avoid duplicate)
            if (this.props.esp32Upload?.phase !== ESP32_UPLOAD_PHASES.error) {
                this.props.onAppendEsp32UploadText?.(`\r\n❌ Error: ${error.message}\r\n`);
                this.props.onSetEsp32UploadPhase?.(ESP32_UPLOAD_PHASES.error);
                this.props.onSetEsp32AbortEnabled?.(true);
            }

            this.props.onUploadError?.(error.message);
            this.props.onShowUploadError?.();

            // Vẫn thông báo console để tiếp tục
            window.dispatchEvent(new CustomEvent('afterUpload'));
        }
    }

    async flashToESP32(device, fileArray) {
        let deviceInfo = device.getInfo();
        let transport = new Transport(device, true);

        const terminal = {
            writeLine: (msg) => {
                console.log(msg);
                this.props.onAppendEsp32UploadText?.(msg + '\r\n');
            },
            write: (msg) => {
                console.log(msg);
                this.props.onAppendEsp32UploadText?.(msg);
            },
            clean: () => {},
            onLineReceived: null,
            rawWrite: (msg) => {},
            read: () => Promise.resolve('')
        };

        const flashOptions_setup = {
            transport,
            baudrate: 115200,
            terminal: terminal,
        };

        let esploader = new ESPLoader(flashOptions_setup);

        try {
            let chip = await esploader.main();

            let chipDescription = 'ESP32';
            if (typeof chip.getChipDescription === 'function') {
                chipDescription = chip.getChipDescription();
            } else if (chip.CHIP_DEFS && chip.CHIP_DEFS.CHIP_NAME) {
                chipDescription = chip.CHIP_DEFS.CHIP_NAME;
            } else if (chip.rom && chip.rom.CHIP_NAME) {
                chipDescription = chip.rom.CHIP_NAME;
            }

            console.log(`Connected to ${deviceInfo.usbProductId ? 'USB Serial Device' : 'Serial Device'} - Chip: ${chipDescription}`);

            await esploader.eraseFlash();
            console.log('Flash erased successfully.');

            const flashOptions = {
                fileArray: fileArray,
                eraseAll: false,
                compress: true,
                reportProgress: (fileIndex, written, total) => {
                    const percent = Math.round((written / total) * 100);
                    console.log(`Flashing file ${fileIndex + 1}/${fileArray.length}: ${percent}%`);
                    if (this.props.onUpdateFlashProgress) {
                        this.props.onUpdateFlashProgress(fileIndex, percent);
                    }
                },
                calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image))
            };

            await esploader.writeFlash(flashOptions);
            await esploader.after();
            console.log('Flashing process completed.');
            console.log('🔄 Resetting ESP32...');
            try {
                // Thử gọi hardReset nếu có
                if (typeof esploader.hardReset === 'function') {
                    await esploader.hardReset();
                    console.log('✓ Hard reset via esploader');
                } else if (transport && typeof transport.setDTR === 'function') {
                    // Reset thủ công bằng DTR/RTS signals
                    await transport.setDTR(false);
                    await transport.setRTS(true);
                    await new Promise(resolve => setTimeout(resolve, 100));
                    await transport.setRTS(false);
                    await new Promise(resolve => setTimeout(resolve, 100));
                    console.log('✓ Hard reset via DTR/RTS');
                } else {
                    // Fallback: gọi after() để reset
                    await esploader.after();
                    console.log('✓ Reset via esploader.after()');
                }
            } catch (resetErr) {
                console.warn('Reset warning:', resetErr);
            }

            console.log('✓ ESP32 should restart now');

        } finally {
            // ✅ Cleanup transport và giải phóng port
            try {
                if (transport && transport.reader) {
                    try {
                        await transport.reader.cancel();
                    } catch (e) {
                        console.warn('Reader cancel failed:', e);
                    }
                    try {
                        transport.reader.releaseLock();
                    } catch (e) {
                        console.warn('Reader release failed:', e);
                    }
                }
                if (transport) {
                    await transport.disconnect();
                    console.log('Transport disconnected.');
                }

                // ✅ Đóng port sau khi flash xong để Console có thể mở lại
                if (device && device.readable) {
                    try {
                        await device.close();
                        console.log('✓ Port closed after flash, ready for console');
                    } catch (e) {
                        console.warn('Port close warning:', e);
                    }
                }

                // Chờ để đảm bảo port đã được giải phóng hoàn toàn
                await new Promise(resolve => setTimeout(resolve, 500));

            } catch (error) {
                console.error('Error during cleanup:', error);
            }

            deviceInfo = null;
            transport = null;
            esploader = null;

            console.log('✓ Flash cleanup completed, port available for console.');
        }
    }

    handleUpload () {
        const {
            codeEditorValue,
            deviceId,
            peripheralName
        } = this.props;

        const blocklyBlockCanvas = document.querySelector('.blocklyWorkspace .blocklyBlockCanvas');
        if (blocklyBlockCanvas.childNodes.length === 0) {
            this.props.onWorkspaceIsEmpty();
            return;
        }
        if (deviceId === 'arduinoEsp32S3') {
            this.handleEsp32S3Upload(codeEditorValue);
            return;
        }
        if (peripheralName) {
            this.props.vm.uploadToPeripheral(deviceId, codeEditorValue);
            this.props.onOpenUploadProgress();
        } else {
            this.props.onNoPeripheralIsConnected();
        }
    }

    render () {
        const {
            ...props
        } = this.props;
        return (
            <HardwareHeaderComponent
                onUpload={this.handleUpload}
                {...props}
            />
        );
    }
}

HardwareHeader.propTypes = {
    baudrate: PropTypes.string,
    codeEditorValue: PropTypes.string,
    deviceId: PropTypes.string,
    onNoPeripheralIsConnected: PropTypes.func.isRequired,
    onOpenUploadProgress: PropTypes.func,
    onWorkspaceIsEmpty: PropTypes.func.isRequired,
    onUploadError: PropTypes.func,
    peripheralName: PropTypes.string,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    uploadUrl: PropTypes.string,
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    baudrate: state.scratchGui.hardwareConsole.baudrate,
    codeEditorValue: state.scratchGui.code.codeEditorValue,
    deviceId: state.scratchGui.device.deviceId,
    peripheralName: state.scratchGui.connectionModal.peripheralName,
    flashProgress: state.scratchGui.flashProgress,
    esp32Upload: state.scratchGui.esp32Upload
});

const mapDispatchToProps = dispatch => ({
    onNoPeripheralIsConnected: () => showAlertWithTimeout(dispatch, 'connectAPeripheralFirst'),
    onSetStageLarge: () => dispatch(setStageSize(STAGE_SIZE_MODES.large)),
    onSetStageSmall: () => dispatch(setStageSize(STAGE_SIZE_MODES.small)),
    onSetStageHide: () => dispatch(setStageSize(STAGE_SIZE_MODES.hide)),
    onOpenUploadProgress: () => dispatch(openUploadProgress()),
    onCloseUploadProgress: () => dispatch(closeUploadProgress()),
    onUpdateFlashProgress: (fileIndex, percent) => dispatch(updateFlashProgress(fileIndex, percent)),
    onResetFlashProgress: () => dispatch(resetFlashProgress()),
    onUpdateInitProgress: (percent) => dispatch(updateInitProgress(percent)),
    onResetInitProgress: () => dispatch(resetInitProgress()),
    onShowUploadSuccess: () => showAlertWithTimeout(dispatch, 'uploadSuccess'),
    onShowUploadEsp32Success: () => showAlertWithTimeout(dispatch, 'uploadEsp32Success'),
    onShowUploadError: () => showAlertWithTimeout(dispatch, 'uploadError'),
    onWorkspaceIsEmpty: () => showAlertWithTimeout(dispatch, 'workspaceIsEmpty'),
    onSetEsp32UploadPhase: (phase) => dispatch(setEsp32UploadPhase(phase)),
    onSetEsp32UploadText: (text) => dispatch(setEsp32UploadText(text)),
    onAppendEsp32UploadText: (text) => dispatch(appendEsp32UploadText(text)),
    onSetEsp32AbortEnabled: (enabled) => dispatch(setEsp32AbortEnabled(enabled)),
    onResetEsp32Upload: () => dispatch(resetEsp32Upload())
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(HardwareHeader);
